import React from 'react';
import styles from './button.module.css';

export const Button = ({ children, onClick, disabled, className = '' }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`${styles.button} ${className}`}
        >
            {children}
        </button>
    );
}; 